import { Injectable } from '@treasury/utils/dependency-injection';
import { ArpAccountsRequests } from '../../requests/arp/arp-accounts';

@Injectable()
export class ArpAccountsService {
    public getArpAccounts(claimType: string) {
        return ArpAccountsRequests.getArpAccounts(claimType);
    }
}
